import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

export default function PneumaticCircuit() {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [force, setForce] = useState("");
  const [pressure, setPressure] = useState("");
  const [efficiency, setEfficiency] = useState("");
  const [diameter, setDiameter] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userEmail) {
      navigate("/signin");
    }
  }, [userEmail, navigate]);

  const calculateDiameter = async () => {
    setError(null);
    try {
      const response = await fetch("https://www.d-rosa.ai/calculatediameter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          force: parseFloat(force),
          pressure: parseFloat(pressure),
          efficiency: parseFloat(efficiency),
        }),
      });

      const data = await response.json();
      if (response.ok) {
        setDiameter(data.diameter);
      } else {
        setError(data.detail);
      }
    } catch (err) {
      setError("Failed to connect to the server.");
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-white rounded-xl shadow-md space-y-4">
      <center>
      <h2 className="text-xl font-bold">Hydraulic & Pnuematic Cylinder</h2>
      </center>
      <p>Signed in as: {userEmail}</p>
      <input
        type="number"
        placeholder="Force (N)"
        value={force}
        onChange={(e) => setForce(e.target.value)}
        className="w-full p-2 border rounded"
      />
      <br /><br />
      <input
        type="number"
        placeholder="Air Pressure (Pa)"
        value={pressure}
        onChange={(e) => setPressure(e.target.value)}
        className="w-full p-2 border rounded"
      />
      <br /><br />
      <input
        type="number"
        placeholder="Efficiency (0-1)"
        value={efficiency}
        onChange={(e) => setEfficiency(e.target.value)}
        className="w-full p-2 border rounded"
      />
      <br /><br />
      <button
        onClick={calculateDiameter}
        className="w-full bg-blue-500 text-white p-2 rounded"
      >
        Calculate Diameter
      </button>

      {diameter && <p className="text-green-600">Required Diameter: {diameter.toFixed(2)} m</p>}
      {error && <p className="text-red-600">{error}</p>}

      <br /><br />

      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
